<template>
  <div>
    <v-card-text>
      <div class="dashboardServicesCards">
        <template v-for="(requestType, index) in visibleCaseRequestTypes">
          <request-type-card
            :key="index"
            :show-tag="requestType.showTag"
            :request-type="requestType"
            @select-case-request-type="setSelectedCaseRequestType"
          ></request-type-card>
        </template>
        <v-col cols="12">
          <naj-no-data
            :has-data="visibleCaseRequestTypes && visibleCaseRequestTypes.length > 0"
            :loading="loading"
          ></naj-no-data>
        </v-col>
      </div>
    </v-card-text>

    <naj-confirmation
      :show-modal="showPrerequisitesInfoModal"
      :max-width="1000"
      :is-persistent="false"
      :title="selectedRequestType.title"
      :sub-title="selectedRequestType.fullExplanation"
      :show-close-btn="false"
      @cancel="() => {
        showPrerequisitesInfoModal = false;
        requestTypePrerequisitesText='';
      }"
    >
      <template slot="message-content">
        <v-row>
          <v-col>
            <naj-alert type="alert">
              <template slot="content">
                {{ local.lawsuitDetails.caseRelatedRequestFeesNote }}
                <a
                  :href="Urls.judicialFees"
                  target="_blank"
                  class="about-link"
                >
                  {{ local.common.clickHere }}
                </a>
              </template>
            </naj-alert>
          </v-col>
        </v-row>
      </template>
      <template slot="actions">
        <naj-button
          :disabled="!pledged"
          @click="() => {
            showPrerequisitesInfoModal = false;
            navigateToApplyingNewRequest();
          }"
        >
          {{ local.common.continue }}
        </naj-button>
      </template>
      <template slot="footer-content">
        <naj-input
          :type-id="formFieldType.checkbox"
          :value.sync="pledged"
          :label="local.lawsuitDetails.caseRelatedRequestPledge"
        ></naj-input>
      </template>
    </naj-confirmation>

    <update-attorney-details
      :form-model="formModel"
      :modal-visibility="showUpdateAttorneyDetailsModal"
      @casePartyAttorneyUpdate="casePartyAttorneyUpdate"
    ></update-attorney-details>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('CasesModule');

import RequestTypeCard from './request-type-card.vue';
import { RequestTypesNames, RequestTypes } from '@/helpers/enum';
import { Urls } from '@/modules/judicialFees/helpers/enum';
import UpdateAttorneyDetails from '../../../../modules/global/components/update-attorney-details';
const { mapState: mapGlobalState } = createNamespacedHelpers('GlobalModule');

export default {
  components: {
    RequestTypeCard,
    UpdateAttorneyDetails,
  },
  data() {
    return {
      loading: false,
      RequestTypesNames,
      RequestTypes,
      selectedRequestType: {},
      showPrerequisitesInfoModal: false,
      requestTypePrerequisitesText: '',
      pledged: false,
      showUpdateAttorneyDetailsModal: false,
      formModel: {},
      visibleCaseRequestTypes: [],
      Urls,
    };
  },
  computed: {
    caseObjectKey() {
      return this.$route.params.caseObjectKey;
    },
    isPega() {
      return this.$route.params.isPega == 'true';
    },
    isCaseRelatedRequests() {
      return !!this.caseObjectKey;
    },
    isFromRequest() {
      return this.$route.params.requestObjectKey;
    },
    isBankruptcyMigrated() {
      return this.$route.query.isBankruptcyMigrated == 'true';
    },

    isGovernmentalUser() {
      return this.userInfo.loginType == 'governmental';
    },
    ...mapGlobalState(['userInfo']),
  },
  mounted() {
    this.loadData();
  },
  methods: {
    ...mapActions([
      'validateRequestIssuance',
      'checkUserHasValidPermission',
    ]),

    setSelectedCaseRequestType(requestType) {
      this.selectedRequestType = requestType;
      this.showPrerequisitesInfoModal = true;
      this.pledged = false;
      this.requestTypePrerequisitesText = 'Ahmed';
    },
    navigateToApplyingNewRequest() {
      if (this.selectedRequestType) {
        const requestTypeName = this.selectedRequestType.name;
        if (this.isCaseRelatedRequests) {
          this.loading = true;
          const params = {
            caseObjectKey: this.caseObjectKey,
            isPega: this.isPega,
            requestTypeId: this.selectedRequestType.id,
            parentRequestObjectKey: this.isFromRequest ? this.$route.params.requestObjectKey : null,
          };

          this.validateRequestIssuance(params)
            .then(({ data }) => {
              if (data) {
                let route = `/cases/${this.caseObjectKey}/case-related-request/${requestTypeName}/new?isPega=${this.isPega}`;
                if (this.isFromRequest) {
                  route += `&requestObjectKey=${this.$route.params.requestObjectKey}`;
                }
                this.$router.push(route);
              }
            })
            .catch(() => { })
            .finally(() => (this.loading = false));
        } else {
          if (requestTypeName === 'legacyCaseDigitalizationRequest') {
            this.$router.push({ path: `/cases/case-digitalization-request/${requestTypeName}` });
          }
          else if (requestTypeName === 'reconsideration-from-non-case-party') {
            this.$router.push({ path: `/cases/reconsideration-from-non-case-party/${requestTypeName}/${true}` });
          }
          else {
            this.$router.push({ path: `/cases/case-related-request/${requestTypeName}/new` });
          }
        }
      }
    },
    loadData() {
      if (!this.caseObjectKey) {
        this.visibleCaseRequestTypes = this.getVisibleCaseRequestTypes();
      } else {
        this.loading = true;
        this.checkUserHasValidPermission(this.caseObjectKey)
          .then((result) => {
            const hasPermissionVal = result?.data?.hasPermission;
            if (hasPermissionVal) {
              this.visibleCaseRequestTypes = this.getVisibleCaseRequestTypes();
            } else if (!hasPermissionVal) {
              this.formModel = {
                attorneyTypeId: result?.data?.attorneyTypeId,
                attorneyNumber: result?.data?.attorneyNumber,
                casePartyId: result?.data?.casePartyId,
                caseObjectKey: this.caseObjectKey,
                casePartyIdentityNumber: result?.data?.casePartyIdentityNumber,
                casePartyRole: result?.data?.casePartyRole,
                isTraineeLawyer: result?.data?.isTraineeLawyer,
              };
              this.showUpdateAttorneyDetailsModal = true;
            }
          }).finally(() => (this.loading = false));
      }
    },
    casePartyAttorneyUpdate() {
      this.showUpdateAttorneyDetailsModal = false;
      this.visibleCaseRequestTypes = this.getVisibleCaseRequestTypes();
    },
    getVisibleCaseRequestTypes() {
      const implementedRequestTypes = Object.values(RequestTypes).filter(rt => rt.isEnabled);

      if (this.isBankruptcyMigrated) {
        return implementedRequestTypes.filter(rt =>
          rt.id === RequestTypesNames.addRepresentative.id
          || rt.id === RequestTypesNames.verdictObjection.id
          || rt.id === RequestTypesNames.joinder.id
          || rt.id === RequestTypesNames.intervenor.id
          || rt.id === RequestTypesNames.addNoteRequest.id
          || rt.id === RequestTypesNames.judgeRejectionRequest.id
          || rt.id === RequestTypesNames.litigationAbandonmentsRequest.id
          || rt.id === RequestTypesNames.incidentalRequest.id
          || rt.id === RequestTypesNames.proceedAbandonedCase.id
          || rt.id === RequestTypesNames.viewCaseRecord.id
          || rt.id === RequestTypesNames.correctionJudgementRequest.id
          || rt.id === RequestTypesNames.interpretationJudgementRequest.id);
      }

      if (this.isFromRequest) {
        return implementedRequestTypes.filter(rt => rt.id === RequestTypesNames.verdictObjection.id
          || rt.id === RequestTypesNames.cassationRequest.id);
      }

      if (this.isCaseRelatedRequests) {
        return implementedRequestTypes.filter(rt => rt.id !== RequestTypesNames.intervenor.id
          && rt.id !== RequestTypesNames.legacyCaseDigitalizationRequest.id && rt.id !== RequestTypesNames.reconsiderationFromNonCaseParty.id);
      }

      if (this.isGovernmentalUser) {
          return implementedRequestTypes.filter(rt => rt.id === RequestTypesNames.intervenor.id
              || rt.id === RequestTypesNames.reconsiderationFromNonCaseParty.id);
      }
      else {
        return implementedRequestTypes.filter(rt => rt.id === RequestTypesNames.addRepresentative.id
        || rt.id === RequestTypesNames.legacyCaseDigitalizationRequest.id
        || rt.id === RequestTypesNames.reconsiderationFromNonCaseParty.id
        || rt.id === RequestTypesNames.intervenor.id);
      }
    },
  },
};
</script>
<style scoped>
.about-link {
  color: #144afa;
  display: inline;
}
</style>